export const projectSectionLinkOffset = (sectionOffset) => {
  document.querySelectorAll("a[href*='#section']").forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault()
      const target = document.querySelector(link.getAttribute('href'))
      const targetOffset = target.offsetTop - sectionOffset
      window.scrollTo({ top: targetOffset, behavior: 'smooth' })
    })
  })
}